import { Archive, Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

interface BulkArchiveDialogProps {
  isOpen: boolean;
  onClose: () => void;
  selectedDealIds: string[];
  onArchive: () => Promise<void>;
  isLoading?: boolean;
}

export const BulkArchiveDialog = ({
  isOpen,
  onClose,
  selectedDealIds,
  onArchive,
  isLoading = false,
}: BulkArchiveDialogProps) => {
  const handleArchive = async () => {
    await onArchive();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Archive className="h-5 w-5 text-yellow-600" />
            Archive {selectedDealIds.length} Deals
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to archive {selectedDealIds.length} deals?
            This will move them to the archived section and they will no longer
            appear in your active deals list.
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <p className="text-sm text-muted-foreground">
            This action can be undone by unarchiving the deals later.
          </p>
        </div>

        <DialogFooter className="flex gap-2">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            onClick={handleArchive}
            disabled={isLoading}
            variant="outline"
            className="text-yellow-600 hover:text-yellow-700 border-yellow-600 hover:border-yellow-700"
          >
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Archiving...
              </>
            ) : (
              <>
                <Archive className="mr-2 h-4 w-4" />
                Archive Deals
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
